// @ts-nocheck
import React from 'react';
import { navigate } from '../../lib/routerAdapter';
import { workingHourContractPriceApi } from './../../lib/api';
import CommonListPage from './../../components/hoc/common/handbook/ListPage';
import Page from '../../components/hoc/common/handbook/PageContext';
import { withUserAccess } from './../withUserAccess';
import { Filter } from './components';
import { formatDateTimeToString } from '../../lib/helpers';
import { approveTypes } from '../../lib/enum';
import { getBreadCrumbsByUrl } from '../../lib/autoBreadcrumbs';
const entryPointPath = '/admin/working-hour-contract-price/';
const columns = [{
  title: 'Филиал',
  dataIndex: 'orgUnitName'
}, {
  title: 'Стоимость нормо-часа работ подрядом без НДС, руб',
  dataIndex: 'price'
}, {
  title: 'Дата начала',
  dataIndex: 'startDate',
  render: startDate => formatDateTimeToString(startDate, 'DD.MM.YYYY')
}, {
  title: 'Дата окончания',
  dataIndex: 'endDate',
  render: endDate => formatDateTimeToString(endDate, 'DD.MM.YYYY')
}, {
  title: 'Статус',
  dataIndex: 'status',
  render: status => approveTypes[status]
}];
const breadCrumbs = getBreadCrumbsByUrl(entryPointPath);
const access = {
  add: () => navigate(`${entryPointPath}new`)
};
export default withUserAccess(({
  userAccess
}) => {
  return <Page>
      <CommonListPage crud={workingHourContractPriceApi} pageHeaderProps={{
      breadCrumbs,
      mainHeader: 'Стоимость нормо-часа подрядным способом',
      access
    }} tableListProps={{
      columns,
      onSelect: id => navigate(`${entryPointPath}${id}`),
      canDelete: true
    }} filter={Filter} />
    </Page>;
});
